<template>
  <page
    :custom-style="{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh'
    }"
  >
    <van-notice-bar
      v-if="noticeTip"
      wrapable
      :scrollable="false"
      color="#ff9600"
      left-icon="warning-o"
      :text="noticeTip"
    />

    <div class="bill-top-info">
      <bill-company
        :page="'export'"
        :bill-company-id="selected_company_id"
        @selectCompany="selectCompany"
      ></bill-company>
      <bill-type
        v-if="selected_type"
        :page="'export'"
        :bill-select-type="selected_type"
        @selectType="selectType"
      ></bill-type>
    </div>
    <div class="pannel">
      <div class="title">时间范围</div>
      <div class="date-wrapper">
        <div class="date" @click="showCalendar = true">
          <div :class="{ selected: !!start }">
            {{ start ? formatDate(start) : '请选择开始日期' }}
          </div>
          <div class="connect">至</div>
          <div :class="{ selected: !!start }">
            {{ end ? formatDate(end) : '请选择结束日期' }}
          </div>
        </div>
      </div>
      <div class="title">接收方式</div>
      <template v-if="browerInfo.isMallApp || isMCMallKeyCustomer">
        <div class="down-select">
          <div class="select-icon" @click="changeIsPhoneDown">
            <IconFont
              :name="
                isPhoneExport ? 'xuankuang-gouxuan' : 'xuankuang-weixuanzhong'
              "
              :color="isPhoneExport ? THEME_COLOR : '#979797'"
              size="16px"
            ></IconFont>
          </div>
          <div class="label">下载文件</div>
        </div>
        <div class="down-select">
          <div class="select-icon" @click="changeEmail">
            <IconFont
              :name="
                isEmailExport ? 'xuankuang-gouxuan' : 'xuankuang-weixuanzhong'
              "
              :color="isEmailExport ? THEME_COLOR : '#979797'"
              size="16px"
            ></IconFont>
          </div>
          <div class="label">电子邮箱</div>
          <van-field
            v-model="email"
            class="email-input"
            :placeholder="isEmailExport ? '请输入电子邮箱' : ''"
            input-align="right"
            :disabled="!isEmailExport"
          />
        </div>
      </template>
      <template v-else>
        <div class="down-select">
          <div class="label">电子邮箱</div>
          <van-field
            v-model="email"
            class="email-input"
            placeholder="请输入电子邮箱"
            input-align="right"
          />
        </div>
      </template>
      <van-button
        :color="THEME_COLOR"
        class="submit"
        round
        block
        @click="submit"
      >
        创建导出任务
      </van-button>
    </div>
    <van-calendar
      v-model="showCalendar"
      title="选择时间范围"
      :color="THEME_COLOR"
      type="range"
      :min-date="minDate"
      :max-date="maxDate"
      :default-date="[start, end]"
      :max-range="days"
      allow-same-day
      @confirm="onConfirmDate"
    />
  </page>
</template>
<script>
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import {
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform'
import { THEME_COLOR } from '@/defines/environment/config'
// import { appKey } from '@/defines/environment'
import BillCompany from './components/BillCompany.vue'
import BillType from './components/BillType.vue'
const emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
export default {
  components: {
    BillCompany,
    BillType
  },
  beforeRouteEnter(to, from, next) {
    navBar.setTitle({
      text: '导出明细'
    })
    next(vm => {
      document.title = '导出明细'
      // eslint-disable-next-line camelcase
      const { start, end } = to.query
      const maxDate = Date.now()
      if (start && end) {
        const maxEndDate = end > maxDate ? maxDate : end
        vm.start = new Date(Number(start))
        vm.end = new Date(Number(maxEndDate))
      }
      // eslint-disable-next-line camelcase
      vm.selected_company_id = to.query?.selected_company_id || ''
      vm.selected_type = to.query?.selected_type || ''
      vm.getBillTip()
    })
  },
  data() {
    return {
      showCalendar: false,
      minDate: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
      maxDate: new Date(Date.now()),
      email: '',
      start: null,
      end: null,
      browerInfo: window.matrix,
      isPhoneExport: true,
      isEmailExport: false,
      noticeTip: '',
      isMCMallKeyCustomer:
        isMCMallKeyCustomerIOS() || isMCMallKeyCustomerAndroid(),
      THEME_COLOR,
      selected_company_id: '',
      selected_type: '',
      days: 365
    }
  },
  methods: {
    selectCompany(companyId) {
      this.selected_company_id = companyId
    },
    selectType(type) {
      this.selected_type = type
    },
    async getBillTip() {
      const res = await API.tpPay.getBillTip({
        selected_company_id: this.selected_company_id
      })
      this.noticeTip = res?.tip || ''
      this.days = res?.intervalDays || 365
      const minDate = res.minDate || ''
      this.minDate = new Date(minDate)
    },
    formatDate(date) {
      const yyyy = date.getFullYear()
      let mm = date.getMonth()
      let dd = date.getDate()
      if (mm < 9) {
        mm = `0${mm + 1}`
      } else {
        mm = mm + 1
      }
      if (dd < 10) {
        dd = `0${dd}`
      }
      return `${yyyy}-${mm}-${dd}`
    },
    onConfirmDate([start, end]) {
      const maxDate = Date.now()
      const endDateTime = end.getTime() + (24 * 3600 - 1) * 1000
      const endDate = endDateTime > maxDate ? maxDate : endDateTime
      this.start = start
      this.end = new Date(endDate)
      this.showCalendar = false
    },
    submit() {
      if (!this.start || !this.end) return this.$toast('请选则时间范围')
      if (this.browerInfo.isMallApp || this.isMCMallKeyCustomer) {
        if (this.isPhoneExport) {
          this.phoneEXport()
        }
        if (this.isEmailExport) {
          this.emailExport()
        }
      } else {
        this.emailExport()
      }
    },
    changeIsPhoneDown() {
      this.isPhoneExport = !this.isPhoneExport
      this.isEmailExport = false
    },
    changeEmail() {
      this.isEmailExport = !this.isEmailExport
      this.isPhoneExport = false
    },
    async emailExport() {
      if (!this.email) return this.$toast('邮箱不能为空')
      if (!emailReg.test(this.email)) return this.$toast('请输入正确的邮箱')
      this.$Loading()
      this.$track(this.$trackMap.bill.billExport)
      try {
        await API.tpPay.exportDetails({
          startTime: this.start.getTime(),
          endTime: this.end.getTime(),
          email: this.email,
          selected_company_id: this.selected_company_id,
          queryType: this.selected_type,
          exportType: 1 // 导出邮箱
        })

        this.$dialog.alert({
          confirmButtonText: '知道了',
          message:
            '创建导出任务成功！请返回上一页，稍后点击【导出列表】查看发送邮箱进度',
          confirmButtonColor: THEME_COLOR
        })
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    async phoneEXport() {
      try {
        await API.tpPay.exportDetails({
          startTime: this.start.getTime(),
          endTime: this.end.getTime(),
          selected_company_id: this.selected_company_id,
          queryType: this.selected_type,
          exportType: 2 // 下载
        })
        this.$dialog.alert({
          confirmButtonText: '知道了',
          message:
            '创建导出任务成功！请返回上一页，稍后点击【导出列表】下载文件',
          confirmButtonColor: THEME_COLOR
        })
      } catch (error) {
        this.$catch(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bill-top-info {
  @include flex-row-between;
  background-color: #fff;
}
.pannel {
  width: 7rem;
  margin: 0.24rem auto 0;
  padding: 0 0 0.4rem;

  background-color: #fff;
  border-radius: 0.16rem;
  .title {
    padding-left: 0.24rem;

    font-size: 0.32rem;
    line-height: 0.92rem;
    font-weight: bold;
    color: #262626;
  }
  .date-wrapper {
    padding: 0 0.24rem;
  }
  .date {
    display: flex;

    height: 0.88rem;
    margin-bottom: 0.4rem;

    border-bottom: 1px solid #f5f5f5;

    justify-content: space-between;
    align-items: center;

    font-size: 0.28rem;
    color: #d9d9d9;
    .connect {
      color: #8c8c8c;
    }
    .selected {
      color: #262626;
    }
  }
  .submit {
    width: 6.36rem;
    margin: 0.64rem auto 0;
  }
  .down-select {
    padding: 0 0.24rem;
    @include flex(row, normal, center);
    .select-icon {
      margin-right: 0.24rem;
    }
  }
  .label {
    white-space: nowrap;
    @include text(0.26rem, #262626, true);
  }
}
</style>
